import { user } from "@solimat/solimat-web-endpoint";
import React, {useState} from "react";  
const BASE_URL = import.meta.env.VITE_REACT_APP_USUARIOS_PATH || "";
const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_USUARIOS_KEY || "";
const userService = new user.UserService(BASE_URL, FUNCTIONS_KEY);


const useVerifyUserData = () => {

  const [loadingVerifyUserData,setLoadingVerifyUserData] = useState<boolean>(false)
  const [errorVerifyUserData,setErrorVerifyUserData] = useState<boolean>(false)
  const [verifyUserDataComplete,setVerifyUserDataComplete] = useState<any|null>(null)

  const VerifyUserData = async (data:any) => {
    setLoadingVerifyUserData(true)
    setErrorVerifyUserData(false)
    try {
      const response = await userService.VerifyUserData(data);
      setLoadingVerifyUserData(false)
      setVerifyUserDataComplete(response)
      return response;
    } catch(err) {
      setLoadingVerifyUserData(false)
      setErrorVerifyUserData(true)
      console.error("VerifyUserData", err);
      return false
    }
  }
  return {
  VerifyUserData,
  loadingVerifyUserData,
  errorVerifyUserData,
  verifyUserDataComplete,

  }
}

export default useVerifyUserData;